module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-1800.468e5c56.webp";